import {
  CheckDiscountCodePayload,
  GetDiscountParams,
  SegmentDiscountCodePayload,
  changeDiscountActivationPayload,
  createDiscountCodePayload,
} from '../../models/payload/discount';
import { offlineRopoloRequest, ropoloRequest } from '../axios';

const checkDiscountCode = async ({
  id,
  customerId,
  isReadOnly,
  networkStatus,
}: CheckDiscountCodePayload & { networkStatus: boolean }) =>
  (
    await (networkStatus
      ? ropoloRequest.identityDiscountcodesGetbycodeDetail(id, { customerId, isReadOnly })
      : offlineRopoloRequest.identityDiscountcodesGetbycodeDetail(id, { customerId, isReadOnly }))
  ).data;

const checkDiscountCodeSite = async (code: string) =>
  (await ropoloRequest.identityDiscountcodesSiteGetbycodeDetail(code)).data;

const getAllDiscount = async (params: GetDiscountParams) =>
  (await ropoloRequest.identityDiscountcodesList(params)).data;
const getDiscountByIdService = async (id: string) => (await ropoloRequest.identityDiscountcodesDetail(id)).data;

const removeDiscountCode = async (id: string) => (await ropoloRequest.identityDiscountcodesDelete(id)).data;

const changeDiscountActivation = async (command: changeDiscountActivationPayload) =>
  (await ropoloRequest.identityDiscountcodesUpdate(command)).data;

const createDiscount = async (command: createDiscountCodePayload) =>
  (await ropoloRequest.identityDiscountcodesCreate(command)).data;

const segmentDiscountCode = async (command: SegmentDiscountCodePayload) =>
  (await ropoloRequest.identityDiscountcodesAvailableList(command)).data;

const segmentDiscountCodeMessage = async ({ id, discountCodeId }: { id: string; discountCodeId: string }) =>
  (await ropoloRequest.identityAvailablesegmentsDiscountcodesMessageDetail(id, discountCodeId)).data;

export {
  changeDiscountActivation,
  checkDiscountCode,
  checkDiscountCodeSite,
  createDiscount,
  getAllDiscount,
  getDiscountByIdService,
  segmentDiscountCode,
  segmentDiscountCodeMessage,
  removeDiscountCode,
};
